







































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ParametrosModel from "@/models/cadastros/saude/ParametrosModel";
import { parametrizacaoService } from "@/service/cadastro/saude/parametrizacao/ParametrizacaoService";
import MessageDialog from "@/components/modal/MessageDialog.vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    MessageDialog,
  },
})
export default class CadastroParametro extends Vue {
  $refs!: {
    cadastroObserver: InstanceType<typeof ValidationObserver>;
  };

  parametros: ParametrosModel = {
    antecedenciaMaximaRemarcarConsulta: 0,
    antecedenciaMaximaAgendamento: 0,
    prazoMaximoFinalizacaoAtendimento: 0,
    prazoRetornoOrcamento: 0,
    prazoValidadeOrcamento: 0
  };

  openDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  dialogStyle = "";
  dialogKey = 0;
  dialog = false;
  dialogType = "";

  acaoDialog(tipo: string) {
    this.openDialog = false;
  }

  gravar() {
    parametrizacaoService
      .atualizar(this.parametros)
      .then((res) => {
        this.dialog = true;
      })
      .catch((err) => {
        this.dialogTitle = err;
        this.dialogMessage = err;
        this.dialogStyle = "error";
        this.dialogType = "";
        this.openDialog = true;
      });
  }

  mounted() {
    this.loadInfo();
  }

  loadInfo() {
    parametrizacaoService.obterParametros().then((res: any) => {
      this.parametros = res;
    });
  }
}
